import { FEATURE_KEYS, ICON_IDS, MODULE_KEYS, OPERATION_IDS, TELEMETRY_IDS } from './ids.js';
export const REPORTING_ROUTE_IDS = Object.freeze({
    LIVE: 'reports-live',
    REGULATORY: 'reports-regulatory',
    OPERATIONS: 'reports-operations',
    OPERATIONS_FIXED_INCOME: 'reports-operations-fixed-income',
    OPERATIONS_VALUATION_RUNS: 'reports-operations-valuation-runs',
    OPERATIONS_CUTOFF_CONTROLS: 'reports-operations-cutoff-controls',
});
const REPORTS = 'nav.reports';
const LIVE = 'reportsWorkspace.navigation.live';
const REGULATORY = 'reportsWorkspace.navigation.regulatory';
const OPERATIONS = 'reportsWorkspace.navigation.operations';
const FIXED_INCOME = 'reportsWorkspace.operations.fixedIncome.title';
const VALUATION_RUNS = 'reportsWorkspace.operations.valuationRuns.title';
const CUTOFF_CONTROLS = 'reportsWorkspace.operations.cutoffControls.title';
const internalPersonas = ['ORG_ADMIN', 'ORG_USER'];
function route(options) {
    return {
        id: options.id,
        schemaVersion: 1,
        module: MODULE_KEYS.REPORTS,
        feature: FEATURE_KEYS.REPORTS_VIEW,
        telemetryId: TELEMETRY_IDS.REPORTS_VIEW,
        accessibilityLabelKey: options.titleKey,
        privacyClassification: 'CONFIDENTIAL',
        auditPolicy: 'ALWAYS',
        owner: 'investment-reporting-ux',
        routeId: options.routeId,
        path: options.path,
        pageId: options.pageId,
        layoutId: 'app',
        authentication: 'authenticated',
        availability: 'AVAILABLE',
        allowedPersonas: [...internalPersonas],
        breadcrumbKeys: options.breadcrumbs,
        navigationPlacement: 'hidden',
        iconId: ICON_IDS.REPORTS,
        titleKey: options.titleKey,
        operationId: OPERATION_IDS.REPORTS_VIEW,
    };
}
export const REPORTING_ROUTES = [
    route({
        id: 'route-reports-live',
        routeId: REPORTING_ROUTE_IDS.LIVE,
        path: '/reports/live',
        pageId: 'page-reports-live',
        titleKey: LIVE,
        breadcrumbs: [REPORTS, LIVE],
    }),
    route({
        id: 'route-reports-regulatory',
        routeId: REPORTING_ROUTE_IDS.REGULATORY,
        path: '/reports/regulatory',
        pageId: 'page-reports-regulatory',
        titleKey: REGULATORY,
        breadcrumbs: [REPORTS, REGULATORY],
    }),
    route({
        id: 'route-reports-operations',
        routeId: REPORTING_ROUTE_IDS.OPERATIONS,
        path: '/reports/operations',
        pageId: 'page-reports-operations',
        titleKey: OPERATIONS,
        breadcrumbs: [REPORTS, OPERATIONS],
    }),
    route({
        id: 'route-reports-operations-fixed-income',
        routeId: REPORTING_ROUTE_IDS.OPERATIONS_FIXED_INCOME,
        path: '/reports/operations/fixed-income',
        pageId: 'page-reports-operations-fixed-income',
        titleKey: FIXED_INCOME,
        breadcrumbs: [REPORTS, OPERATIONS, FIXED_INCOME],
    }),
    route({
        id: 'route-reports-operations-valuation-runs',
        routeId: REPORTING_ROUTE_IDS.OPERATIONS_VALUATION_RUNS,
        path: '/reports/operations/valuation-runs',
        pageId: 'page-reports-operations-valuation-runs',
        titleKey: VALUATION_RUNS,
        breadcrumbs: [REPORTS, OPERATIONS, VALUATION_RUNS],
    }),
    route({
        id: 'route-reports-operations-cutoff-controls',
        routeId: REPORTING_ROUTE_IDS.OPERATIONS_CUTOFF_CONTROLS,
        path: '/reports/operations/cutoff-controls',
        pageId: 'page-reports-operations-cutoff-controls',
        titleKey: CUTOFF_CONTROLS,
        breadcrumbs: [REPORTS, OPERATIONS, CUTOFF_CONTROLS],
    }),
];
